import React, { useContext, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import Login from "../Content/Login/Login";
import NuevaContraseña from "../Content/NuevaContraseña";
import RecuperarContraseña from "../Content/Login/RecuperarContraseña";
import Inicio from "../Content/Inicio/Inicio";
import Chat from "../Content/Chat/Chat";
import Usuarios from "../Content/Usuarios";
import PoliticasPrivacidad from "../Content/PoliticasPrivacidad";
import EliminarCuenta from "../Content/EliminarCuenta";
import Layout from "../Layout/Layout";

import "animate.css";

import { AuthContext } from "../../Auth";
import appe from "../../firebase-config";
import PageDisabled from "../Content/PageDisabled";
import PagePending from "../Content/PagePending";
import RegistroProvider from "../Content/Login/RegistroProvider";
import UsuarioPasado from "../Content/Login/UsuarioPasado";
import DataBase from "../Content/DataBase/DataBase";
import { Footer } from "antd/lib/layout/layout";
import { version } from "../../Version";

export default function App() {
  const { currentUser, userData, authReady } = useContext(AuthContext);

  useEffect(() => {
    appe.messaging()
      .getToken({
        vapidKey:
          "BC4A7MYW_iMHYNNhIAwmrNt1DBZBI5hP9BdUfgzYHl6Y0iyzWCSfjNfa55FaO-6J4idqAUImpZiYLLxMx8FtJ_w"
      })
      .then()
      .catch((err) => console.log(err));
  }, []);

  const isLogged = !!currentUser;

  if (!authReady) {
    return null;
  }

  return (
    <BrowserRouter>
      <Routes>

        {/* PÚBLICAS */}
        <Route path="/politicas-privacidad" element={<PoliticasPrivacidad />} />
        <Route path="/recuperar" element={<RecuperarContraseña />} />
        <Route path="/nueva" element={<NuevaContraseña />} />
        <Route path="/existente" element={<UsuarioPasado />} />
        <Route path="/registro" element={<RegistroProvider />} />

        {!isLogged ? (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <Route path="*" element={<PrivateRoutes userData={userData} />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}

// ====================================
// 🔵 COMPONENTE SEPARADO PARA RUTAS PRIVADAS
// ====================================
function PrivateRoutes({ userData }) {
  if (!userData) {
    return null;
  }

  return (
    <Layout>
      <Routes>
        {userData.estado === "enabled" && (
          <>
            <Route path="/" element={<Inicio />} />
            <Route path="/chat" element={<Chat />} />

            {userData.tipoUsuario === "Administrador" && (
              <>
                <Route path="/usuarios" element={<Usuarios />} />
                <Route path="/database" element={<DataBase />} />
              </>
            )}

            <Route path="/eliminar_cuenta" element={<EliminarCuenta />} />
          </>
        )}

        {userData.estado === "disabled" && (
          <Route path="*" element={<PageDisabled />} />
        )}

        {userData.estado === "pending" && (
          <Route path="*" element={<PagePending />} />
        )}
      </Routes>

      <Footer style={{ textAlign: "center", padding: 10 }}>
        ({version}) StormAlertaWeb © {new Date().getFullYear()} - Created by Centinela S&I
      </Footer>
    </Layout>
  );
}
